import { ComponentProps } from 'components/VirtualizedTable/types';
import { Location } from 'generated/models';
import { useCallback } from 'react';
import gtm from 'trackers/gtm';
import LocationLocator from '../LocationLocator';

const LocatorCell = ({ row: { masterId, name } }: ComponentProps<Location>) => {
  const handleTrackLocator = useCallback(() => gtm.trackClickLocationsLocator(name), [name]);

  return <LocationLocator masterId={masterId} variant="table" onTrack={handleTrackLocator} />;
};

export default LocatorCell;
